import { Link } from "react-router-dom";
import YellowLine from "../../../assets/svg/yellow-line.svg";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import sal from "sal.js";

function DownloadSection() {
  const ImageURL = process.env.REACT_APP_API_IMAGE_URL;

  const { data: homeContet } = useSelector(
    (x) => x?.home?.homePageContentResponse
  );
  useEffect(() => {
    sal();
  }, [homeContet]);

  return (
    <section className="downloads">
      <div className="yellow-line">
        <img src={YellowLine} alt="yellow-line" />
      </div>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-12">
            <h1 className="main-title text-center">
              {homeContet?.downloadSectionMainTitle}
            </h1>
          </div>
          <div className="col-lg-3">
            <div
              className="download-cards"
              data-sal="slide-up"
              data-sal-duration="900"
              data-sal-delay="100"
            >
              <img
                src={ImageURL + homeContet?.downloadFirstCardImage}
                className="card-img-top"
                alt="2006 Strategic Plan"
              />
              <h5 className="card-title">
                {homeContet?.downloadFirstCardTitle}
              </h5>
              <Link
                target="_new"
                to={ImageURL + homeContet?.downloadFirstCardUrl}
                className="download-link"
              >
                Download{" "}
                <span>
                  <i className="fa fa-long-arrow-right" aria-hidden="true"></i>
                </span>
              </Link>
            </div>
          </div>
          <div className="col-lg-3">
            <div
              className="download-cards"
              data-sal="slide-up"
              data-sal-duration="900"
              data-sal-delay="200"
            >
              <img
                src={ImageURL + homeContet?.downloadSecondCardImage}
                className="card-img-top"
                alt="2006 Strategic Plan"
              />
              <h5 className="card-title">
                {homeContet?.downloadSecondCardTitle}
              </h5>
              <Link
                target="_new"
                to={ImageURL + homeContet?.downloadSecondCardUrl}
                className="download-link"
              >
                Download{" "}
                <span>
                  <i className="fa fa-long-arrow-right" aria-hidden="true"></i>
                </span>
              </Link>
            </div>
          </div>
          <div className="col-lg-3">
            <div
              className="download-cards"
              data-sal="slide-up"
              data-sal-duration="900"
              data-sal-delay="300"
            >
              <img
                src={ImageURL + homeContet?.downloadThirdCardImage}
                className="card-img-top"
                alt="2006 Strategic Plan"
              />
              <h5 className="card-title">
                {homeContet?.downloadThirdCardTitle}
              </h5>
              <Link
                target="_new"
                to={ImageURL + homeContet?.downloadThirdCardUrl}
                className="download-link"
              >
                Download{" "}
                <span>
                  <i className="fa fa-long-arrow-right" aria-hidden="true"></i>
                </span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default DownloadSection;
